import { cn } from "@lib/cn";
import { useGetPagesCountQuery } from "@/shared/services";
import { UpgradeButton, useLockedAction } from "../index";

const PLAN_STYLES = {
  container: {
    starter: "tw-bg-starter-background tw-border-starter-base/30",
    pro: "tw-bg-pro-background tw-border-pro-base/30",
    team: "tw-bg-team-background tw-border-team-base/30",
  },
  progressBarBg: {
    starter: "tw-bg-starter-base/30",
    pro: "tw-bg-pro-base/30",
    team: "tw-bg-team-base/30",
  },
  progressBarFill: {
    starter: "tw-bg-starter-base",
    pro: "tw-bg-pro-base",
    team: "tw-bg-team-base",
  },
  text: {
    starter: "tw-text-starter-base",
    pro: "tw-text-pro-base",
    team: "tw-text-team-base",
  },
};

const LiveStoriesLimit = () => {
  const { data } = useGetPagesCountQuery({ status: "Live" });
  const { value: limit, plan } = useLockedAction({
    feature: "live-stories",
  });
  if (typeof limit !== "number") return null;

  const count = data?.count || 0;
  const percentage = Math.min((count / limit) * 100, 100);

  return (
    <div
      className={cn(
        "tw-flex tw-items-center tw-gap-4 tw-rounded-xl tw-border tw-border-solid tw-pl-3 tw-pr-1 tw-py-1",
        PLAN_STYLES.container[plan as keyof typeof PLAN_STYLES.container],
      )}
    >
      <div className="tw-flex tw-w-[230px] tw-items-center tw-gap-3">
        <p className="tw-shrink-0 tw-font-sans tw-text-xs tw-font-semibold tw-leading-4 tw-text-blue">
          Live stories limit
        </p>
        <div className="tw-flex tw-flex-1 tw-items-center tw-gap-2">
          <div
            className={cn(
              "tw-relative tw-h-[6px] tw-flex-1 tw-overflow-hidden tw-rounded-[32px]",
              PLAN_STYLES.progressBarBg[
                plan as keyof typeof PLAN_STYLES.progressBarBg
              ],
            )}
          >
            <div
              className={cn(
                "tw-absolute tw-left-0 tw-top-0 tw-h-[6px] tw-rounded-[32px]",
                PLAN_STYLES.progressBarFill[
                  plan as keyof typeof PLAN_STYLES.progressBarFill
                ],
              )}
              style={{
                width: `${percentage}%`,
              }}
            />
          </div>
          <p
            className={cn(
              "tw-shrink-0 tw-text-right tw-font-sans tw-text-xs tw-font-semibold tw-leading-4",
              PLAN_STYLES.text[plan as keyof typeof PLAN_STYLES.text],
            )}
          >
            {count}/{limit}
          </p>
        </div>
      </div>
      <UpgradeButton plan={plan} feature="live-stories" size="xs" />
    </div>
  );
};

export default LiveStoriesLimit;
